import { FC } from "react";
import styled from "styled-components";

import { Application } from "../../../api/models/Application";
import { PrimaryButton, SecondaryButton } from "../../../styles/basicComponents";
import { LoadingContainer, ModalBody, ModalContent, ModalField, ModalFieldTitle, ModalFieldValue, ModalFooter, ModalSection, ModalTitle, ModalWrapper } from "./styledComponents";
import { useTheme } from "../../../features/context/CustomerContext";
import { BackArrowIcon } from "./modalIcons";
import useCustomTranslation from "../../../features/hooks/CustomUseTranslation";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";

const Error = styled.p`
    display: inline;
    color: red;
`

export interface ApplicationModalProps {
    application: Application;
    show: boolean;
    modalType: string;
    showError: boolean;
    closeModal: () => void;
    handleClick: (modalType: string) => void;
    applicationRequestPending: boolean;
}

const ApplicationModal: FC<ApplicationModalProps> = (props) => {
    const { t } = useCustomTranslation();
    const theme = useTheme();

    if (!props.show || props.modalType === '') {
        return null;
    }

    var startDate = (props.application && props.application.startDate) ? props.application.startDate.toLocaleDateString("fi-FI") : '';
    var endDate = (props.application && props.application.endDate) ? props.application.endDate.toLocaleDateString("fi-FI") : '';

    return (
        <ModalWrapper theme={theme}>
            <ModalContent theme={theme}>
                <BackArrowIcon theme={theme} onClick={() => props.closeModal()} />
                <ModalTitle theme={theme}>
                    {t(props.modalType + " application")}
                </ModalTitle>
                <ModalBody>
                    {props.applicationRequestPending &&
                        <LoadingContainer theme={theme}>
                        <LoadingSpinner/>
                    </LoadingContainer>}
                    {props.modalType === 'Delete' &&
                        <ModalSection>
                            <ModalField> {t("Are you sure you want to delete following application?")}</ModalField>
                        </ModalSection>
                    }
                    <ModalSection>
                        <ModalField>
                            <ModalFieldTitle>{t("Applicant")}</ModalFieldTitle>
                            <ModalFieldValue>{props.application?.requestorUser?.username}</ModalFieldValue>
                        </ModalField>

                        <ModalField>
                            <ModalFieldTitle>{t("Receiver username")}</ModalFieldTitle>
                            <ModalFieldValue>{props.application?.requesteeUsername}</ModalFieldValue>
                        </ModalField>

                        <ModalField>
                            <ModalFieldTitle>{t("Requested customer")}</ModalFieldTitle>
                            <ModalFieldValue>{props.application?.requesteeCustomerNumber}</ModalFieldValue>
                        </ModalField>

                        <ModalField>
                            <ModalFieldTitle>{t("Period of validity")}</ModalFieldTitle>
                            <ModalFieldValue>{startDate} - {endDate}</ModalFieldValue>
                        </ModalField>

                        <ModalField>
                            {props.showError ? <Error>{t("Error when trying to " + (props.modalType === 'Accept' ? 'accept application' : 'decline application'))} </Error> : <br />}
                        </ModalField>
                    </ModalSection>
                </ModalBody>
                <ModalFooter>
                    <SecondaryButton theme={theme} onClick={() => props.closeModal()}>{t("Back")}</SecondaryButton>
                    <PrimaryButton theme={theme} disabled={props.applicationRequestPending} onClick={() => props.handleClick(props.modalType)}>{t(props.modalType)}</PrimaryButton>
                </ModalFooter>
            </ModalContent>
        </ModalWrapper>
    )
}

export default ApplicationModal;